import { ORGANIZATION_STATUS } from "@/features/organization/constants/organizationList";
import { useRef } from "react";

type TUseGetOrganizationList = {
  active: number;
  archive: number;
  deleted: number;
  isFetching: boolean;
};

export const useGetOrganizationList = ({ active = 0, archive = 0, deleted = 0, isFetching }: TUseGetOrganizationList) => {
  const cache = useRef({
    active: 0,
    archive: 0,
    deleted: 0,
  });

  if (active !== undefined && !isFetching) cache.current.active = active;
  if (archive !== undefined && !isFetching) cache.current.archive = archive;
  if (deleted !== undefined && !isFetching) cache.current.deleted = deleted;

  const { active: a, archive: ar, deleted: d } = cache.current;

  return [
    { label: `利用中 (${a})`, value: ORGANIZATION_STATUS.ACTIVE },
    { label: `アーカイブ済み (${ar})`, value: ORGANIZATION_STATUS.ARCHIVED },
    { label: `データ消去済み (${d})`, value: ORGANIZATION_STATUS.DELETED },
  ];
};
